import Iconify from '@/components/iconify';
import {
    Box, Button,
    Dialog,
    IconButton,
    Stack,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import CreateApiKeyForm from './CreateApiKeyForm';


CreateApiKeyButton.propTypes = {
    setApiKeyInfo: PropTypes.func.isRequired,
}

export default function CreateApiKeyButton({ setApiKeyInfo }) {

    const [open, setOpen] = useState(false)

    const handleCloseDialog = () => {
        setOpen(false)
    }
    const handleOpenDialog = () => {
        setOpen(true)
    }
    return (
        <>
            <Button className='w-full lg:w-max' onClick={handleOpenDialog} variant='contained'>
                Criar chave API
            </Button>

            <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCloseDialog}>
                <Stack sx={{ bgcolor: 'background.default' }} p={2} gap={2}>
                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                        <Typography variant="h4">Criar Chave API</Typography>
                        <IconButton onClick={handleCloseDialog}  >
                            <Iconify icon="eva:close-fill" />
                        </IconButton>
                    </Box>

                    <CreateApiKeyForm open={open} handleCloseDialog={handleCloseDialog} setApiKeyInfo={setApiKeyInfo} />
                </Stack>
            </Dialog>
        </>
    )
}